export default __webpack_public_path__ + "static/media/careerWordpress.c17f936b.png";